import { clsx } from "clsx";
import { type HTMLAttributes, forwardRef } from "react";

type TableContainerProps = HTMLAttributes<HTMLDivElement>;

export const TableContainer = forwardRef<HTMLDivElement, TableContainerProps>(
	function TableContainer({ className, children, ...props }, ref) {
		return (
			<div
				className={clsx(
					"overflow-auto border border-grey-200 bg-white",
					className,
				)}
				ref={ref}
				{...props}
			>
				{children}
			</div>
		);
	},
);
